// extracted by mini-css-extract-plugin
export default {"dbSwitch":"Switch_dbSwitch__X65Ro","indicator":"Switch_indicator__Ii+zk","isChecked":"Switch_isChecked__B9A1Q","isDisabled":"Switch_isDisabled__gF0lH"};